module.exports = __webpack_public_path__ + "static/media/  (129).a3ea4abe.jpg";